// @flow
import React, { Fragment } from "react";
import { compose, withState, withHandlers } from "recompose";
import styled from "styled-components";
import StoreButtons from "../common/StoreButtons";
import { Button, PrimaryButton } from "../common/Button";
// import { TextInput as TextInputBase } from "../common/TextInput";
import ReactCountryFlag from "react-country-flag";
import topNineIcon from "../../../images/icon.png";
import doneImg from "../../../images/done.png";
import downloadAppImg from "../../../images/download-app.svg";
import appStoreImg from "../../../images/app-store.svg";
import playStoreImg from "../../../images/play-store.svg";

const isIphone = typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isMobileDevice = typeof window.orientation !== "undefined";

const DisableLogin = (props) => {
  if (props.error && props.error.name === "WebDisabledError") {
    return <MessageForWebDisabled {...props} />;
  } else {
    return <MessageForJoinWaitlist {...props} />;
  }
};

const MessageForWebDisabled = ({ error, email }) => (
  <Container>
    <CountryContainer>
      <Title>
        Whoa! Top Nine is currently used by millions of users worldwide.
        <br />
        {`Don't worry! We will email your Top Nine ${email ? `top ${email}` : ""}`}
      </Title>
    </CountryContainer>
    <Text>If you would like to get your Top Nine now, please download our mobile app.</Text>

    {!isIphone && <Text>Just follow the link below</Text>}
    <StoreButtonsPrivate onlyDeviceButton={isMobileDevice} isIphone={isIphone} style={{ marginBottom: "10px" }} />
    <SmallText>
      We will email your Top Nine when it's done. Please contact our support team if you have any questions!
    </SmallText>
  </Container>
);

const StoreButtonsPrivate = styled(StoreButtons)`
  margin-top: 0px !important;
`;

const APP_STORE_URL = "https://itunes.apple.com/us/app/top-nine-for-instagram-2017/id1188477208?mt=8";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bestnine&hl=en";

const MessageForJoinWaitlist = compose(
  withState("email", "setEmail", ({ email }) => email),
  withState("submitStatus", "setSubmitStatus", "idle"),
  withHandlers({
    onChangeEmail: (props) => ({ target }) => props.setEmail(target.value),
    handleJoinWaitlist: (props) => (event) => {
      event.preventDefault();

      const query = new URLSearchParams({
        email: props.email,
        subscribeKey: "f19e0284-05c9-402f-9509-8562494f246c",
        redirectOnSuccess: "",
        redirectOnFailure: "",
      }).toString();

      props.setSubmitStatus("busy");
      fetch(`https://m4g-svc-prd.betalabs.studio/api/list/subscribe/?${query}`, {
        method: "GET",
      })
        .then(() => {
          props.setEmail("");
          props.setSubmitStatus("success");
          return new Promise((resolve, _reject) => {
            setTimeout(resolve, 3000);
          });
        })
        .then(() => {
          props.onRequestClose && props.onRequestClose();
          props.setSubmitStatus("idle");
        })
        .catch((error) => {
          console.error(error);
          props.setSubmitStatus("idle");
        });
    },
  })
)(({ email, onChangeEmail, handleJoinWaitlist, ...props }) => {
  return (
    <Fragment>
      <Container>
        {props.submitStatus == "success" && (
          <Fragment>
            <Headline>Thank you!</Headline>
            <Illustration src={doneImg} resizeMode="contain" alt="Join the waitlist" />
            <Text>{"We'll get back to you as soon as Top Nine 2020 is ready!"}</Text>
          </Fragment>
        )}

        {props.submitStatus != "success" && (
          <Fragment>
            <Headline>Coming Soon!</Headline>
            <Illustration src={downloadAppImg} resizeMode="contain" alt="Join the waitlist" />
            <Text>Top Nine 2020 to be announced in a few days!</Text>
            <Text>Subscribe below to get notified:</Text>
            <JoinWaitlistForm onSubmit={handleJoinWaitlist}>
              {/* <TextInput
                type="email"
                required
                value={email}
                placeholder={"Your email"}
                onChange={onChangeEmail}
              /> */}
              <PrimaryButton>{props.submitStatus == "idle" ? "Subscribe" : "Submitting..."}</PrimaryButton>
            </JoinWaitlistForm>
          </Fragment>
        )}
      </Container>
    </Fragment>
  );
});

// 😠🔪
const LinkOverlay = styled.a`
  display: block;
  position: fixed;
  left: -100%;
  top: -100%;
  width: 400vw;
  height: 400vh;
`;

export const FakeStoreButton = ({ isIphone }) => (
  <FakeStoreButtonContainer>
    <img
      src={isIphone ? appStoreImg : playStoreImg}
      alt={isIphone ? "Download on the App Store" : "Get it on Play Store"}
    />
  </FakeStoreButtonContainer>
);

const FakeStoreButtonContainer = styled.div`
  margin: 8px;
  display: flex;
  width: 45%;
  max-width: 140px;
  justify-content: center;
  align-content: center;
  position: relative;
  border-radius: 4px;
  background: #000000;
  border: 2px solid currentColor;
  border-color: transparent;
  color: #fff;
  white-space: nowrap;
  font-weight: 500;
  line-height: 1.4;
  cursor: pointer;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const StoreButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 10px;
`;

const CountryContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const DownloadBullets = styled.div`
  margin: 8px auto;
  @media (max-height: 600px) {
    margin: 0px auto;
  }
`;

const DownloadBullet = styled.li`
  padding: 0;
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 600;
  text-align: center;
  @media (max-height: 600px) {
    font-size: 11px !important;
  }
  b {
    color: #f74255;
  }
`;
const Container = styled.div`
  background: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  text-align: center;
  width: 400px;
  max-width: 100%;
`;

const Title = styled.h3`
  text-align: center;
  margin: 18px auto;
`;

const Headline = styled.h3`
  text-align: center;
  margin: 18px auto;
  font-size: 24px;
`;

const Text = styled.p`
  color: black;
  margin-bottom: 8px !important;
  font-size: 14px !important;
  text-align: center;
  @media (max-height: 600px) {
    font-size: 11px !important;
  }
`;

const Thanks = styled.p`
  width: 100%;
  text-align: center;
  font-weight: bolder;
  color: black;
  font-size: 14px;
  margin-bottom: 10px !important ;
`;
/* margin: 0px !important; */

const FinalText = styled(Text)`
  margin-bottom: 20px !important ;
`;

const Illustration = styled.img`
  height: 120px;
  width: auto;
  margin: 10px auto;
  margin-bottom: 20px;
  display: block;
  object-fit: contain;
  @media (max-height: 600px) {
    height: 90px;
  }
`;

const ButtonContainer = styled.div`
  width: 95%;
  margin: auto;
`;

const SmallText = styled(Text)`
  opacity: 0.9;
  font-size: 12px !important;
`;

// const TextInput = styled(TextInputBase)`
//   text-align: center;
//   border: solid 1px #ccc;
//   border-radius: 5px;
// `

const JoinWaitlistForm = styled.form`
  & > * {
    margin-top: 8px;
  }
`;

export default DisableLogin;
